import * as moment from 'moment';

import { msToDays } from '../utils';
import * as lifeEventTypes from './lifeEvents.types';

export function calculateWorkedMs(driver) {
  const { currentLifeEvent } = driver;
  if (!currentLifeEvent || currentLifeEvent.eventType !== lifeEventTypes.types.WORK) {
    return 0;
  }
  return moment().valueOf() - (currentLifeEvent.startedAt || 0);
}

export function calculateWorkedDays(driver) {
  return msToDays(calculateWorkedMs(driver));
}

export function calculateAccWorkedMs(driver) {
  const { currentLifeEvent } = driver;
  if (!currentLifeEvent) { return 0; }

  const accWork = !currentLifeEvent.accWork || currentLifeEvent.accWork < 0
    ? 0
    : currentLifeEvent.accWork;

  return calculateWorkedMs(driver) + accWork;
}

export function calculateAccWorkedDays(driver) {
  return msToDays(calculateAccWorkedMs(driver));
}



// WEBPACK FOOTER //
// ./src/Driver/helpers.js